export class task{
    id: number | undefined;
    name: string | undefined;
}